import { RedoFulfillmentLocationSchema } from "@redotech/redo-model/fulfillments/fulfillment-location";
import * as z from "zod/v4";

export const getLocationsForRoutingRules = {
  name: "getLocationsForRoutingRules" as const,
  input: z.object({}),
  output: z.object({ locations: z.array(RedoFulfillmentLocationSchema) }),
};
